<template>
    <div class="module goodsListModule white_bg">

        <searchBar ref="searchBar" @search="onSearch"/>

        <div class="" style="padding: 0 6px;">

            <bannerModule4 :itemCount="99" version="4" categoryKey="SHOP_GOODS_LIST" />

        </div>

        <div class="filterArea marginT10" style="padding-left: 12px;">
                <span class="textLabel yellowTextLabel" :class="{active : '' == filters.category}"
                      @click="filters.category = ''; reloadDataList();">
                    全部
                </span>
            <span class="textLabel yellowTextLabel" :class="{active : typeFilterItem.id == filters.category}"
                  v-for="typeFilterItem in typeList" :key="typeFilterItem.id"
                  @click="filters.category = typeFilterItem.id; reloadDataList();">
                    {{typeFilterItem.name}}
                </span>
        </div>

        <div class="marginT10">
            <Waterfall :list="dataList" :gutter="8" :width="240"
                       :breakpoints="waterfallOptions.breakpoints"
                       animationEffect="fadeInUp" ref="waterfall"
            >
                <template slot="item" slot-scope="props">
                    <!--                    <div class="card">-->
                    <!--                        <img :src="props.data.src" alt="" @load="$refs.waterfall.refresh()">-->
                    <!--                        ...-->
                    <!--                    </div>-->
                    <div class="dataItem paddingB20" @click="viewItem(props.data)">
                        <div class="imageArea">
                            <img class="block" :src="props.data.coverImg" width="100%" height="auto"
                                 style="min-height: 60px;" @load="$refs.waterfall.refresh()"/>
                        </div>
                        <div class="marginT12 color101010 font14r">
                            {{props.data.title}}
                        </div>
                        <div class="font12r clearfix marginT8">
                            <strong class="red fl">￥{{props.data.price}}</strong>
                            <span class="grey777 fr">{{props.data.payCount ? props.data.payCount + '+' : props.data.payCount}}人付款</span>
                        </div>
                    </div>
                </template>
            </Waterfall>

            <div class="alignCenter paddingV8" v-show="status === 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'ready' &&  dataList.length < 1">
                暂无任何实物
            </div>

            <div class="paddingV16 alignCenter font14r colorCCC"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                没有更多实物了
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'error'">
                加载数据失败
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import searchBar   from "../search/searchBar";
import bannerModule4 from '../ad/bannerModule4';
import Waterfall from "vue-waterfall-plugin";

// config
import appConfig from '@/appConfig';

// network api
import categoryApi from '@/api/category';

// util
import consoleApi       from '@/components/platformApi/consoleApi';
import numberHelper     from '@/util/numberHelper';
import appHelper        from '@/util/appHelper';
import arrayHelper      from "@/util/arrayHelper";
import routeHelper      from "@/util/routeHelper";
import windowHelper from "@util/windowHelper";

const config = {
    name : 'goodsListModule',
    apiConfig : {
        list : {
            url : 'portal/spu/list',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '十二生肖绘画小手册十二生肖绘画小手册',
        'LOGO玩具',
        '步步高学习机'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        searchBar, bannerModule4, Waterfall
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            pageKey: 'goods-list',
            apiConfig : config.apiConfig,
            pageSize : 12,
            enableDataList : true,
            // autoLoadDataList : appConfig.mode != 'demo',

            filters : {
                category : '',
                title : '',
            },

            searchInputbox : {
                column : 'title'
            },

            typeList : [{
                id : '手册',
                name : '手册'
            },{
                id : '手举牌',
                name : '手举牌'
            },{
                id : '会员卡',
                name : '会员卡'
            }],

            waterfallOptions : {
                breakpoints : {
                    1200: { //当屏幕宽度小于等于1200
                        rowPerView: 4,
                    },
                    800: { //当屏幕宽度小于等于800
                        rowPerView: 3,
                    },
                    500: { //当屏幕宽度小于等于500
                        rowPerView: 2,
                    }
                }
            }
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('shopGoodsDetail', {
                id : dataItem.id
            });
        },
    },
    mounted() {

        const me = this;

        categoryApi.loadList('SPU', (list) => {
            this.typeList = list;
        });

        if (appConfig.mode == 'demo')
        {
            this.dataList.push({
                id : 'logo',
                title : arrayHelper.getRandomItem(config.demoTitleList),
                coverImg : 'http://shixun-test-media.oss-cn-shenzhen.aliyuncs.com/vl/img/f2eaddfff6e04ed1993baed27dd36b8c.png',
                userHead : appHelper.getRandomCoverImage(),
                price : numberHelper.getRandomInteger(20) + '.' + numberHelper.getRandomInteger(10),
                payCount : numberHelper.getRandomInteger(100),
                createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7)
            });
            for (let i=1; i<=28; i++)
            {
                this.dataList.push({
                    id : i,
                    title : arrayHelper.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    price : numberHelper.getRandomInteger(20) + '.' + numberHelper.getRandomInteger(10),
                    payCount : numberHelper.getRandomInteger(100),
                    createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                });
            }
        }

        const catId = routeHelper.getParam(this, 'typeId') || '';
        catId ? this.filters.category = catId : null;

        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>
.color101010 {
    color: #101010;
}
.red {
    color: #F42418;
}
.grey777 {
    color: #777;
}
.filterArea {
    .textLabel {
        width: 70px;
        height: 36px;
        line-height: 36px;
        border: none;
        padding: 0;
        border-radius: 4px;
        margin-right: 16px;
        margin-bottom: 16px;
        background-color: hsla(230, 30%, 96%, 1);
        text-align: center;
        font-size: 14px;
        color: hsla(219, 9%, 39%, 1);
        &.active {
            background-color: hsla(36, 100%, 57%, 1);
            color: white;
        }
    }
}
</style>
